export default __webpack_public_path__ + "static/media/Icons__trane-logo.277df6fe.svg";